import { Fragment } from "react";
import { Link } from "react-router-dom";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { MdSwapHorizontalCircle } from "react-icons/md";
import drawerToggle from "../assets/img/drawer-close.png";
import instagram from "../assets/img/instagram.png";
import facebook from "../assets/img/facebook.png";
import linkdin from "../assets/img/linkedin.png";

const MobileDrawer = ({ open, toggle, navLinks }) => {
  return (
    <Drawer open={open} onClose={toggle} direction="right" zIndex={99999}>
      <div className="py-5 flex flex-col h-full bg-[#5B21B6]">
        <div className="flex items-center">
          <Link
            to="/shitswap"
            onClick={toggle}
            className="max-w-[180px] h-[40px] ml-auto px-4 rounded-full bg-[#E71CA5] hover:bg-[#E71CA5]/90 shadow-glow-pink flex items-center justify-center transition-all"
          >
            <div className="flex text-sm gap-2 items-center text-white font-Poppins font-bold">
              <MdSwapHorizontalCircle className="text-lg" />
              ShitSwap
            </div>
          </Link>
          <img
            src={drawerToggle}
            alt="drawerToggle"
            onClick={toggle}
            className="cursor-pointer"
          />
        </div>
        <hr className="mt-4" />
        <ul className="flex flex-col gap-y-4 mb-8 mt-2">
          {navLinks.map(({ id, text, path, internal }) => {
            const className =
              "capitalize text-[18px] font-Poppins ml-0 hover:ml-2 w-full text-white duration-300 transition-all hover:text-[#E71CA5]";
            return (
              <Fragment key={id}>
                <li className="mx-auto">
                  {internal ? (
                    <Link
                      to={path}
                      onClick={toggle}
                      className={className}
                    >
                      {text}
                    </Link>
                  ) : (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className={className}
                      href={path}
                    >
                      {text}
                    </a>
                  )}
                </li>
                <hr />
              </Fragment>
            );
          })}
        </ul>
        <div className="ml-auto mt-auto mb-3 flex gap-2 mr-3">
          {icons.map(({ id, icon, path }) => (
            <a
              href={path}
              target="_blank"
              rel="noreferrer"
              key={id}
              className="w-[35px] gradient text-2xl h-[35px] rounded-full bg-white flex items-center justify-center"
            >
              {icon}
            </a>
          ))}
        </div>
      </div>
    </Drawer>
  );
};

export default MobileDrawer;
const icons = [
  {
    id: 1,
    path: "https://www.instagram.com/shinyheffers/",
    icon: <img src={instagram} alt="img" className="w-[15px] h-[15px]" />,
  },
  {
    id: 2,
    path: "https://www.facebook.com/shinyheffers",
    icon: <img src={facebook} alt="img" className="w-[10px] h-[20px]" />,
  },
  {
    id: 3,
    path: "https://www.linkedin.com/company/shinyheffers/",
    icon: <img src={linkdin} alt="img" className="w-[19px] h-[19px]" />,
  },
];
